import React, { useEffect } from 'react'
import { useAdminStore } from '../../../store/userStore'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { checkAdminApi } from '../../../api/admin/auth'

const AdminProtectedRoute = () => {
    const { adminInfo, adminLogoutAction } = useAdminStore(state => state)
    const location = useLocation()

    useEffect(() => {
        const checkAdminInfo = async (userId) => {
            try {
                await checkAdminApi(userId)
            }
            catch (error) {
                adminLogoutAction() // 로그아웃 처리
            }
        }

        if (adminInfo) {
            // 백엔드 유저 검사
            checkAdminInfo(adminInfo.user_id)
        } else {
            adminLogoutAction()
        }
    }, [])

    return adminInfo ? <Outlet /> : <Navigate to={'/hy-admin/login'} replace={true} state={{ from: location }} />
}

export default AdminProtectedRoute